<script>
  import { Button } from "../../../Components";
  export let myeventPageName;
  export let active = false;
  export let showEventsSubPage;
</script>

{#if !active}
  <Button
    ghost
    on:click={() => {
      showEventsSubPage(myeventPageName);
    }}
  >
    <slot />
  </Button>
{:else}
  <Button>
    <slot />
  </Button>
{/if}
